export default __webpack_public_path__ + "static/media/17.9b8bc599.svg";